import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { GIS_ZHKH_PRICE_LABEL, GIS_ZHKH_SERIAL_HINT } from './constants';
import GisZhkkhNotice from './GisZhkkhNotice';

const noticeIconClassName = 'mt-0.5 shrink-0 text-orange-500';

const GisZhkkhSubscribeNotice = () => (
  <div className="mb-4 space-y-2">
    <GisZhkkhNotice icon={<InfoOutlinedIcon className={noticeIconClassName} fontSize="small" />}>
      Платная подписка {GIS_ZHKH_PRICE_LABEL}. После оформления вы будете перенаправлены на оплату. Поиск прибора в ГИС ЖКХ может занять несколько секунд.
    </GisZhkkhNotice>
    <GisZhkkhNotice icon={<WarningAmberRoundedIcon className={noticeIconClassName} fontSize="small" />} className="mt-2">
      {GIS_ZHKH_SERIAL_HINT}
    </GisZhkkhNotice>
  </div>
);

export default GisZhkkhSubscribeNotice;
